var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gallery inner"},_vm._l((_vm.item.images),function(image,index){return _c('div',{directives:[{name:"bgimage",rawName:"v-bgimage",value:(image.image),expression:"image.image"}],key:index,staticClass:"gallery-item"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }